import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 101,
  label: "IPC申请量分析",
  chart: charts.lineAndBar,
  definition: {
    rowDims: [{ name: "ipcName", label: "IPC分类", limit: 10, table: "patent_ipc", needTotal: true }],
    colDims: [],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "IPC申请量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false
  }
};
